import { Container, Segment, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Anontools from '@plone/volto/components/theme/Anontools/Anontools';
import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import Logo from '@plone/volto/components/theme/Logo/Logo';
import Navigation from '@plone/volto/components/theme/Navigation/Navigation';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import headerMobileImage from 'assets/images/header-image-mobile.jpg';
import config from '@plone/volto/registry';

const Header = ({ pathname }) => {
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const [isMobile, setIsMobile] = useState(false);

  // Funzione per verificare se il dispositivo è mobile
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768); // Considera mobile se la larghezza è minore o uguale a 768px
  };

  // Aggiungi event listener per il resize della finestra
  useEffect(() => {
    // Controlla la dimensione dello schermo all'inizio
    checkIsMobile();
    
    // Aggiungi event listener per il resize
    window.addEventListener('resize', checkIsMobile);
    
    // Cleanup dell'event listener quando il componente viene smontato
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  // Gestiamo l'URL della home in maniera diversa in base al formato
  const getHomeUrl = () => {
    // Per i link interni, utilizzare Link di react-router-dom
    return '/';
  };

  // Verifica se l'URL è esterno (inizia con http o https)
  const isExternalUrl = (url) => {
    return url && (url.startsWith('http://') || url.startsWith('https://'));
  };

  return (
    <>
      {/* Barra superiore blu */}
      <div className="top-blue-bar">&nbsp;</div>
      
      <Segment basic className="header-wrapper" role="banner">
        <Container>
          <Grid columns={2} verticalAlign="middle">
            <Grid.Column width={6}>
              {isMobile ? (
                <div className="mobile-header-image">
                  {/* Utilizziamo un normale tag <a> per la homepage */}
                  <a href="/" title="Home">
                    <img 
                      src={headerMobileImage} 
                      alt="Homepage" 
                      className="mobile-logo-image" 
                    />
                  </a>
                </div>
              ) : (
                <Logo />
              )}
            </Grid.Column>
            <Grid.Column width={6} textAlign="right">
              <SearchWidget />
            </Grid.Column>
          </Grid>
        </Container>

        {/* Menu di navigazione a larghezza intera */}
        <div className="full-width-menu">
          <Container>
            <Navigation pathname={pathname} />
          </Container>
        </div>
      </Segment>
    </>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};